import { ElementType, FC } from 'react';
import { CardActionArea as MuiCardActionArea, CardActionAreaProps } from '@mui/material';

export const CardActionArea: FC<CardActionAreaProps<ElementType>> = (props) => (
  <MuiCardActionArea disableTouchRipple sx={{ flexDirection: 'inherit', height: '100%' }} {...props} />
);
